import DownloadIcon from "@mui/icons-material/Download"
import { ReactElement } from "react"

import useDownload from "../../../services/middleware/hooks/useDownload"
import {
    DNO_ATTACHMENT,
    INSTALLER_ATTACHMENT,
} from "../../../services/middleware/urls/hybrid"
import AppLoadingButton from "../../buttons/appLoadingButton"
import AppTooltip from "../../helper/appTooltip"

type TSingleAttachmentProps = {
    applicationId: string
    filename: string
    fileUrl: string
    isDnoMode: boolean
    disabled?: boolean
}

const MAX_FILE_NAME_LENGTH = 30

/**
 * Component for displaying and downloading a single attachment.
 */
const SingleAttachment = ({
    applicationId,
    filename,
    fileUrl,
    isDnoMode,
    disabled,
}: TSingleAttachmentProps): ReactElement => {
    const { downloadAttachment, isLoading } = useDownload()

    const handleDowload = (): void => {
        if (isDnoMode === false) {
            downloadAttachment(INSTALLER_ATTACHMENT(applicationId, fileUrl))
        } else {
            downloadAttachment(DNO_ATTACHMENT(applicationId, fileUrl))
        }
    }

    return (
        <AppTooltip
            title={
                disabled
                    ? "This application has been redacted meaning this file is no longer available to review!"
                    : `Click to download ${filename}`
            }
        >
            <span>
                <AppLoadingButton
                    startIcon={<DownloadIcon />}
                    variant="outlined"
                    fullWidth
                    loading={isLoading}
                    style={{ justifyContent: "flex-start" }}
                    onClick={handleDowload}
                    disabled={disabled}
                >
                    {filename.length <= MAX_FILE_NAME_LENGTH
                        ? filename
                        : `${filename.slice(0, MAX_FILE_NAME_LENGTH - 3)}...`}
                </AppLoadingButton>
            </span>
        </AppTooltip>
    )
}

SingleAttachment.defaultProps = {
    disabled: false,
}

export default SingleAttachment
